import { useState, Fragment, ChangeEvent } from 'react';
import { Grid } from '@mui/material';
import SectionTitleDescription from './section-title-description';
import DeleteAlertModal from 'system/components/shared/delete-alert';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useNavigate, useParams } from 'react-router';
import PmiTextField from 'shell/components/shared/text-field';

interface DescriptionDetailProps {
  handleChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  descriptionValue: string;
  code: string;
  lastUpdate: string;
  isEdit?: boolean;
  disabled?: boolean;
  errorDescriptionValue?: string;
  touchedDescriptionValue?: boolean;
  title?: string;
}

const Description = ({
  handleChange,
  descriptionValue,
  lastUpdate,
  code,
  errorDescriptionValue,
  touchedDescriptionValue,
  title,
  disabled,
}: DescriptionDetailProps): React.ReactElement => {
  const params = useParams();
  const navigate = useNavigate();
  const [deleteAlertModal, setDeleteAlertModal] = useState<boolean>(false);

  const { delete: deleteGroup } = useHttpFetch(`${__MANAGEMENT_API_URL__}/gruppi`);

  return (
    <Fragment>
      {/* <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-groups-content"
          id="panel-groups-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        > */}
      <SectionTitleDescription title={title || 'Nuovo Gruppo'} />
      {/* </AccordionSummary>
        <AccordionDetails> */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <PmiTextField
            label="ID Gruppo"
            id="code"
            name="code"
            fullWidth
            type="text"
            variant="outlined"
            value={code || ''}
            onChange={handleChange}
            disabled
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <PmiTextField
            error={touchedDescriptionValue && Boolean(errorDescriptionValue)}
            helperText={errorDescriptionValue}
            label="Nome gruppo *"
            id="name"
            name="name"
            fullWidth
            type="text"
            inputProps={{ maxLength: '50' }}
            variant="outlined"
            value={descriptionValue || ''}
            onChange={handleChange}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <PmiTextField
            label="Contesto ultimo aggiornamento"
            id="lastUpdate"
            name="lastUpdate"
            fullWidth
            inputProps={{ maxLength: '50' }}
            type="text"
            variant="outlined"
            value={lastUpdate || ''}
            onChange={handleChange}
            disabled={disabled}
          />
        </Grid>
      </Grid>
      {/* </AccordionDetails>
      </Accordion> */}
      <DeleteAlertModal
        title="Cancellazione Operatore"
        message="Confermare la cancellazione del gruppo?"
        open={deleteAlertModal}
        onClose={() => setDeleteAlertModal(false)}
        onYes={() => {
          deleteGroup(params.id).then(() => {
            setDeleteAlertModal(false);
            navigate('/sistema/gruppi');
          });
        }}
        onNo={() => setDeleteAlertModal(false)}
      />
    </Fragment>
  );
};
Description.displayName = 'Group detail component';

export default Description;
